<template>
  <footer>
    <v-container fluid class="px-0">
      <div class="dflex footer-sitemap white--text">
        <div class="sitemap-link pa-3">
          <router-link to="#"> Help center </router-link>
        </div>
        <div class="sitemap-link pa-3">
          <router-link to="#"> Terms & Privacy </router-link>
        </div>
        <div class="sitemap-link pa-3">
          <router-link to="#"> Report a bug </router-link>
        </div>
      </div>
      <div class="dflex justify-space-between copyright-footer">
        <p class="pa-3">©YouSound, Inc..</p>
      </div>
    </v-container>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  computed: {
    onMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  data() {
    return {
      aboutLinks: [
        { text: "Discover", route: "/yousound#video" },
        { text: "Download apps", route: "/yousound#video" },
        {
          text: "Case studies",
          ext: true,
          route: "https://support.yousound.com/en/collections/2401816-careers",
        },
      ],
      companyLinks: [
        { text: "About", route: "/terms#privacy_policy" },
        { text: "Careers", route: "/terms#terms_of_use" },
        { text: "Terms", ext: true, route: "https://support.yousound.com/" },
        { text: "Privacy", ext: true, route: "https://support.yousound.com/" },
      ],
      supportLinks: [
        { text: "Help Center", route: "/terms#privacy_policy" },
        { text: "FAQ", route: "/terms#terms_of_use" },
        {
          text: "Server Status",
          ext: true,
          route: "https://support.yousound.com/",
        },
        {
          text: "Report a bug",
          ext: true,
          route: "https://support.yousound.com/",
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
footer {
  .height-normal {
    font-size: 16px;
    height: 34px !important;
  }
  .inner-footer {
    max-width: 1200px;
    width: 100%;
    margin: 60px auto 50px;

    .flex-app {
      display: flex;
      gap: 15px;
      flex-wrap: wrap;
      margin-top: 25px;
    }
  }
  border-top: 1px solid #eff0f6;

  .divider-div {
    border-top: 1px solid #eff0f6;
    padding-top: 30px;
    margin: 0 !important;
    font-size: 16px;
    line-height: 26px;
    color: #424242;
  }

  h3 {
    font-weight: 700 !important;
    font-size: 20px;
    line-height: 28px;
    color: #000000;
    letter-spacing: -0.3px;
  }
  .v-list-item {
    .v-list-item__title {
      color: #000000 !important;
    }
  }

  /deep/.list__tile--link {
    &:hover {
      background: transparent;
    }
  }

  .subscribe_btn {
    max-width: 130px;
    width: 100%;
    height: 40px;
    box-shadow: none !important;
    text-transform: capitalize;
    box-sizing: border-box;
    border-radius: 100px;
    font-style: normal;
    font-weight: 700 !important;
    font-size: 16px !important;
    line-height: 22px !important;
    color: #ffffff !important;
    letter-spacing: normal;
    background: #000000 !important;
    border: 2px solid #000000;
  }
  input {
    border: 2px solid #cbcbcb;
    box-sizing: border-box;
    border-radius: 100px;
    height: 40px;
    margin-right: 10px;
    padding: 8px 18px;
    &:focus {
      outline: none;
    }
  }

  .footer-icons {
    display: flex;
    gap: 20px;

    .footer-social-icon {
      width: 20px;
      height: 20px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
    }
  }
}

@media (max-width: 960px) {
  footer {
    padding-top: 10px;
    .inner-footer {
      padding: 55px 44px;
    }
    h3 {
      text-align: center;
    }
    .list__tile {
      font-size: 14px;
      color: #424242;
      .list__tile__title {
        text-align: center;
      }
    }
    .logo-container {
      display: flex;
      justify-content: center;
      max-height: 30px;
      img {
        height: 25px;
      }
    }
    .appstore-logo-wrapper {
      margin: 20px auto !important;

      .appstore-logo {
        height: 47px;
        margin-bottom: 20px;
      }
    }
  }
}

.copyright-footer {
  color: #fff;
  font-feature-settings: "clig" off, "liga" off;
  font-family: "Space Grotesk";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// Footer-2.vue?c445587e